module.exports = __webpack_public_path__ + "static/media/lens1.32917b4e.png";